import { Component, ViewChild } from '@angular/core';
import { DxPivotGridComponent } from 'devextreme-angular/ui/pivot-grid';
import DevExpress from 'devextreme/bundles/dx.all';
import moment from 'moment';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { ABaseComponent } from '../../../../shared/modules/ui/components/abstract/a-base.component';
import { LoggerService } from '../../../../shared/sdk';
import PivotGridDataSourceOptions = DevExpress.data.PivotGridDataSourceOptions;

@Component({
  selector: 'app-pivot',
  templateUrl: './pivot.component.html',
  styleUrls: ['./pivot.component.scss'],
})
export class PivotComponent extends ABaseComponent {
  @ViewChild(DxPivotGridComponent, { static: true }) grid: DxPivotGridComponent;

  dataSource: any;
  grid_stateStoring: any;

  showTotalsPrior = false;
  rowsDataFieldArea = false;
  treeHeaderLayout = false;

  showColumnTotals = true;
  showRowTotals = true;
  showColumnGrandTotals = true;
  showRowGrandTotals = true;

  collection = 'BillingPivotData';
  exportFileName = 'Billing_Pivot_' + moment().format('YYYY-MM-DD HH:mm:ss');

  constructor(
    public logger: LoggerService,
    private dss: DataSourceService,
  ) {
    super(logger);

    this.grid_stateStoring = {
      enabled: true,
      type: 'localStorage',
      storageKey: 'e1c7b56d-1193-4751-aeba-8edd450d6592',
    };

    this.dataSource = {
      remoteOperations: true,
      store: this.dss.createMongoStore(this.collection),
      // filter: ['tenant', '<>', 'MD'],
      fields: [
        { dataField: '_id', visible: false },
        { area: 'column', dataField: 'date', dataType: 'date', groupInterval: 'year' },
        { area: 'column', dataField: 'date', dataType: 'date', groupInterval: 'quarter' },
        { area: 'column', dataField: 'date', dataType: 'date', groupInterval: 'month' },
        { dataField: 'date', dataType: 'date', groupInterval: 'day' },

        { dataField: 'serviceType', dataType: 'string', caption: 'Service Type', isMeasure: false, area: 'row' },
        { dataField: 'broker', dataType: 'string', caption: 'Broker', isMeasure: false, area: 'row' },
        // { dataField: 'mco', dataType: 'string', caption: 'MCO', isMeasure: false, area: 'row' },
        { dataField: 'tenant', dataType: 'string', caption: 'Tenant', isMeasure: false, area: 'row' },
        { dataField: 'validationState', dataType: 'string', caption: 'V8n State', isMeasure: false, area: 'row' },

        ...[
          { dataField: 'signsTotal', caption: 'Services Conducted', area: 'data' },
          { dataField: 'signsWithTripID', caption: 'Issued Auths', area: 'data' },
          { dataField: 'signsWoTripID', caption: 'Services w/o Auth', area: 'data' },
          // { dataField: 'signsWithUniqTripID', caption: 'Issued Auths (uniq in subset)', area: 'data' },
          { dataField: 'signsMultiAssigned', caption: 'Services MultiAssigned', area: 'data' },
          { dataField: 'signsHasClaim', caption: 'Services Billed', area: 'data' },
          { dataField: 'signsWoClaim', caption: 'Services UnBilled', area: 'data' },

          { dataField: 'tripsWoClaim', caption: 'Auths UnBilled', area: 'data' },

          { dataField: 'claimsTotalBilled', caption: 'Claims Total Billed', area: 'data' },
          { dataField: 'claimsPending', caption: 'Claims Pending', area: 'data' },
          { dataField: 'claimsPaid', caption: 'Claims Paid', area: 'data' },
          { dataField: 'claimsDenied', caption: 'Claims Denied', area: 'data' },
          { dataField: 'claimsCancelled', caption: 'Claims Cancelled', area: 'data' },
        ].map(i => ({
          ...i,
          dataType: 'number',
          summaryType: 'sum',
          isMeasure: true,
        })),

        //

        ...[
          { dataField: 'claimsTotalBilledValue', caption: '$ Claims Total Billed', area: 'data' },
          { dataField: 'claimsPendingValue', caption: '$ Claims Pending', area: 'data' },
          { dataField: 'claimsPaidValue', caption: '$ Claims Paid', area: 'data' },
          { dataField: 'claimsDeniedValue', caption: '$ Claims Denied', area: 'data' },
          { dataField: 'claimsCancelledValue', caption: '$ Claims Cancelled', area: 'data' },
        ].map(i => ({
          ...i,
          dataType: 'number',
          summaryType: 'sum',
          format: 'currency',
          isMeasure: true,
        })),
      ],
    } as PivotGridDataSourceOptions;
  }
}
